module.exports = __webpack_public_path__ + "img/face_tipsnew.ddde5f06.gif";